// This file ensures React is available globally before any external scripts run
import React from 'react';
import ReactDOMClient from 'react-dom/client';
import * as ReactJSXRuntime from 'react/jsx-runtime';

// Expose React globally for external scripts (like gptengineer.js)
if (typeof window !== 'undefined') {
  (window as any).React = React;
  (window as any).ReactDOM = ReactDOMClient;
  (window as any).ReactJSXRuntime = ReactJSXRuntime;
  
  console.log('React globals initialized:', {
    React: !!window.React,
    ReactDOM: !!window.ReactDOM,
    forwardRef: typeof React.forwardRef
  });
}
